import { render, staticRenderFns } from "./shouquan.vue?vue&type=template&id=04356048&scoped=true"
import script from "./shouquan.vue?vue&type=script&lang=js"
export * from "./shouquan.vue?vue&type=script&lang=js"
import style0 from "./shouquan.vue?vue&type=style&index=0&id=04356048&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04356048",
  null
  
)

export default component.exports